export enum EModalIds {
  auth = "auth",
}
